import { useMemo } from "react";
import GetPublicAssetsForEditCoverDocument from "src/api/graphql/__generated__/documents/GetPublicAssetsForEditCoverDocument";
import PublicAssetTag from "src/api/graphql/__generated__/enums/PublicAssetTag";
import PublicAssetVariant from "src/api/graphql/__generated__/enums/PublicAssetVariant";
import useRevalidatedQuery from "src/hooks/useRevalidatedQuery";
import { EditCoverPosterListItem } from "../types";

const useEditCoverPosterContentData = ({
	publicAssetVariant,
	numColumns,
	assetTag,
}: {
	publicAssetVariant: PublicAssetVariant;
	numColumns: number;
	assetTag?: PublicAssetTag;
}) => {
	const { data, loading } = useRevalidatedQuery(GetPublicAssetsForEditCoverDocument, {
		variables: {
			input: {
				variant: publicAssetVariant,
				limit: 1_000,
			},
		},
	});

	const assetTags = useMemo<PublicAssetTag[]>(() => {
		const tagCounts: Partial<Record<PublicAssetTag, number>> = {};
		for (const item of data?.getPublicAssets?.payload ?? []) {
			for (const tag of item.tags ?? []) {
				tagCounts[tag] = (tagCounts[tag] ?? 0) + 1;
			}
		}
		const tagCandidates = Object.keys(tagCounts).slice(0, 100) as PublicAssetTag[];
		const sortedTags = tagCandidates.sort((a, b) => {
			const countA = tagCounts[a] ?? 0;
			const countB = tagCounts[b] ?? 0;
			return countB - countA;
		});
		return sortedTags;
	}, [data?.getPublicAssets?.payload]);

	const publicAssets = useMemo<EditCoverPosterListItem[]>(() => {
		const items = data?.getPublicAssets?.payload ?? [];
		if (assetTag) {
			return items.filter((item) => (item.tags ?? []).includes(assetTag));
		}
		return items;
	}, [data?.getPublicAssets?.payload, assetTag]);
	return {
		publicAssets,
		assetTags,
		loading,
	};
};
export default useEditCoverPosterContentData;
